import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuShiftDefectsView } from "src/tenantCustomizations/tenants/mellano/views/luukku/production/MellanoLuukkuShiftDefectsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/shiftDefects")({
	staticData: { title: "Vuoron viat", legacyViewKey: "mellanoLuukkuShiftDefectsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuShiftDefectsView />;
}
